import {corePublicApolloClient, throwGQLErrorMessage} from '../../utils/apollo-client';
import { createUser as mutation } from '../graphql/sign-up';

export default async function createUserApi(variables) {
  const response = await corePublicApolloClient()
    .then((client) =>
      client.mutate({
        mutation,
        variables
      })
    )
    .catch(throwGQLErrorMessage);

  return response.data.createUser;
}
